import { createTypes, createAction } from "lib/action";

const LOAD_PAYMENTCHANNEL = createTypes("paymentchannel", "load");
const SHOW_PAYMENTCHANNEL = createTypes("paymentchannel", "show");
const CREATE_PAYMENTCHANNEL = createTypes("paymentchannel", "create");
const UPDATE_PAYMENTCHANNEL = createTypes("paymentchannel", "update");
const DELETE_PAYMENTCHANNEL = createTypes("paymentchannel", "delete");

const loadPaymentChannels = {
  request: (params, token) => createAction(LOAD_PAYMENTCHANNEL.REQUEST, { params, token }),
  success: data => createAction(LOAD_PAYMENTCHANNEL.SUCCESS, { data }),
  failure: err => createAction(LOAD_PAYMENTCHANNEL.FAILURE, { err }),
};

const showPaymentChannel = {
  request: (id, token) => createAction(SHOW_PAYMENTCHANNEL.REQUEST, { id, token }),
  success: data => createAction(SHOW_PAYMENTCHANNEL.SUCCESS, { data }),
  failure: err => createAction(SHOW_PAYMENTCHANNEL.FAILURE, { err }),
};

const createPaymentChannel = {
  request: (params, token) => createAction(CREATE_PAYMENTCHANNEL.REQUEST, { params, token }),
  success: data => createAction(CREATE_PAYMENTCHANNEL.SUCCESS, { data }),
  failure: err => createAction(CREATE_PAYMENTCHANNEL.FAILURE, { err }),
};

const updatePaymentChannel = {
  request: (params, id, token) => createAction(UPDATE_PAYMENTCHANNEL.REQUEST, { params, id, token }),
  success: data => createAction(UPDATE_PAYMENTCHANNEL.SUCCESS, { data }),
  failure: err => createAction(UPDATE_PAYMENTCHANNEL.FAILURE, { err }),
};

const deletePaymentChannel = {
  request: (id, token) => createAction(DELETE_PAYMENTCHANNEL.REQUEST, { id, token }),
  success: id => createAction(DELETE_PAYMENTCHANNEL.SUCCESS,  { id } ),
  failure: err => createAction(DELETE_PAYMENTCHANNEL.FAILURE, { err }),
};


export {
  loadPaymentChannels,
  showPaymentChannel,
  createPaymentChannel,
  updatePaymentChannel,
  deletePaymentChannel,
  LOAD_PAYMENTCHANNEL,
  SHOW_PAYMENTCHANNEL,
  CREATE_PAYMENTCHANNEL,
  UPDATE_PAYMENTCHANNEL,
  DELETE_PAYMENTCHANNEL,
};
